import { motion } from "framer-motion";
import { MapPin, Phone, AtSign, Clock } from "lucide-react";
import { CONTACT } from "../../data/site";
import { revealUp, staggerParent, viewportOnce } from "../../lib/motion";

const Row = ({ icon: Icon, label, value }) => (
  <motion.div variants={revealUp} className="flex items-start gap-4 border-t border-white/10 py-5">
    <Icon className="mt-0.5 h-5 w-5 shrink-0 text-labyellow" strokeWidth={2} />
    <div>
      <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-labyellow">{label}</p>
      <p className="mt-1 font-body text-base text-paper">{value}</p>
    </div>
  </motion.div>
);

export const ContactDetails = () => {
  const mapSrc = `https://www.google.com/maps?q=${encodeURIComponent(CONTACT.mapsQuery)}&output=embed`;
  const directions = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(CONTACT.mapsQuery)}`;

  return (
    <div className="flex h-full flex-col gap-6">
      <motion.div
        initial="hidden"
        whileInView="show"
        viewport={viewportOnce}
        variants={staggerParent}
        className="rounded-[28px] bg-inkred px-7 py-10 sm:px-10 sm:py-12"
      >
        <motion.p variants={revealUp} className="mb-2 font-mono text-xs uppercase tracking-[0.3em] text-labyellow">
          THE COORDINATES
        </motion.p>
        <motion.h2 variants={revealUp} className="font-display text-2xl uppercase leading-tight tracking-tight text-paper sm:text-3xl">
          THE DOORS ARE OPEN.
        </motion.h2>

        <div className="mt-6">
          <Row icon={MapPin} label="Address" value={CONTACT.address} />
          <Row icon={Phone} label="Phone" value={CONTACT.phone} />
          <Row icon={AtSign} label="Social" value={CONTACT.social} />
          <Row icon={Clock} label="Hours" value="Mon – Sun / 11:00 – 23:00" />
        </div>

        <motion.a
          variants={revealUp}
          href={directions}
          target="_blank"
          rel="noreferrer"
          data-testid="contact-directions"
          className="mt-8 inline-flex items-center justify-center rounded-full bg-labred px-8 py-3.5 font-display text-xs uppercase tracking-wider text-paper transition-colors duration-150 hover:bg-labyellow hover:text-inkred"
        >
          Get Directions
        </motion.a>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={viewportOnce}
        transition={{ duration: 0.6 }}
        className="map-dark relative min-h-[280px] flex-1 overflow-hidden rounded-[28px]"
      >
        <iframe
          title="Chicken Labb location"
          src={mapSrc}
          className="absolute inset-0 h-full w-full border-0"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          data-testid="contact-map"
        />
      </motion.div>
    </div>
  );
};
